/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import axios, {AxiosError} from 'axios';
import AppConfig from "../../AppConfig";

const AXIOS_TIMEOUT = AppConfig.HTTP.Timeout;

export default class FrontAPI
{
    constructor() {}

    public async httpGet(url: string, headers: any = {}, params: any = undefined, body: any = undefined)
    {
        try
        {
            return await axios.get(url, {
                timeout: AXIOS_TIMEOUT,
                headers: headers,
                params: params,
                data: body
            })
        }
        catch(e)
        {
            throw await this._httpError(e as AxiosError);
        }
    }

    public async httpPost(url: string, payload: any|null = null, headers: any = {}, params: any = undefined)
    {
        try
        {
            return await axios.post(url, payload, {
                headers:  headers,
                timeout: AXIOS_TIMEOUT ,
                params: params
            });
        }
        catch(e: any|AxiosError)
        {
            if((e as AxiosError).response?.data)
            {
                throw (e as AxiosError).response?.data;
            }
            else
            {
                throw await this._httpError(e);
            }
        }
    }

    public async httpPut(url: string, payload: any|null = null, headers: any = {})
    {
        try
        {
            return await axios.put(url, payload, {
                headers:  headers,
                timeout: AXIOS_TIMEOUT ,
            });
        }
        catch(e: any|AxiosError)
        {
            if((e as AxiosError).response?.data)
            {
                throw (e as AxiosError).response?.data;
            }
            else
            {
                throw await this._httpError(e);
            }
        }
    }

    public async httpDelete(url: string, payload: any|null = null ,headers: any = {})
    {
        try
        {
            return await axios.delete(url, {
                headers:  headers,
                timeout: AXIOS_TIMEOUT ,
                data:payload
            });
        }
        catch(e: any|AxiosError)
        {
            if((e as AxiosError).response?.data)
            {
                throw (e as AxiosError).response?.data;
            }
            else
            {
                throw await this._httpError(e);
            }
        }
    }

    public isHttpSuccess(code: number) {
        return code >= 200 && code <= 299;
    }

    protected async _httpError(httpError: AxiosError) 
    {
        await this._log(">>> API._httpError(axiosError)");
        await this._log(httpError.message);
        await this._log( 
            (httpError.response?.status)
        );
        return httpError.message;
    }

    public traduzirMensagemErro(mensagem: any) {
        switch(mensagem) {
            case "Request failed with status code 401":
                return "Sessão expirada. Por favor, faça login novamente.";
            default:
                return mensagem;
        }
    }

    protected async _log(msg: any)
    {
        console.error(msg);
    }
}